export default __webpack_public_path__ + "static/media/large-rock.d1b35d27.png";